import React from 'react';
import { X, ChevronLeft, ChevronRight as ChevronRightIcon, Camera } from 'lucide-react';

export default function GaleriaCompleta({ 
  imagenesProcesadas, 
  currentGalleryImage, 
  onClose, 
  onNext, 
  onPrev, 
  getSafeImageUrl 
}) {
  return (
    <div 
      className="fixed inset-0 z-[300] flex items-center justify-center p-4 bg-black/90 backdrop-blur-md animate-in fade-in duration-300"
      onClick={onClose}
    >
      <div 
        className="max-w-6xl w-full max-h-[90vh] bg-black rounded-2xl overflow-hidden relative"
        onClick={(e) => e.stopPropagation()}
      >
        {/* Botón Cerrar Galería */}
        <button
          onClick={onClose}
          className="absolute top-6 right-6 z-20 p-3 bg-black/50 backdrop-blur-md hover:bg-black rounded-full shadow-lg border border-white/10 transition-all text-white hover:text-red-400"
        >
          <X size={24} />
        </button>

        {/* Botones de Navegación */}
        {imagenesProcesadas.length > 1 && (
          <>
            <button
              onClick={(e) => {
                e.stopPropagation();
                onPrev();
              }}
              className="absolute left-6 top-1/2 -translate-y-1/2 z-20 p-3 bg-black/50 backdrop-blur-md hover:bg-black rounded-full shadow-lg border border-white/10 transition-all text-white hover:text-blue-400"
            >
              <ChevronLeft size={24} />
            </button>
            <button
              onClick={(e) => {
                e.stopPropagation();
                onNext();
              }}
              className="absolute right-6 top-1/2 -translate-y-1/2 z-20 p-3 bg-black/50 backdrop-blur-md hover:bg-black rounded-full shadow-lg border border-white/10 transition-all text-white hover:text-blue-400"
            >
              <ChevronRightIcon size={24} />
            </button>
          </>
        )}

        {/* Imagen Principal de la Galería */}
        <div className="relative w-full h-[70vh] flex items-center justify-center">
          {imagenesProcesadas.length > 0 ? (
            <img
              src={getSafeImageUrl(imagenesProcesadas[currentGalleryImage])}
              alt={`Imagen ${currentGalleryImage + 1}`}
              className="max-w-full max-h-full object-contain"
              onError={(e) => {
                e.target.src = 'https://via.placeholder.com/800x600?text=Error+Carga+Imagen';
              }}
            />
          ) : (
            <div className="text-white text-center p-10">
              <Camera size={64} className="mx-auto mb-4 opacity-50" />
              <p className="text-lg">No hay imágenes disponibles</p>
            </div>
          )}
          
          {/* Contador de Imágenes */}
          {imagenesProcesadas.length > 1 && (
            <div className="absolute bottom-4 left-1/2 -translate-x-1/2 bg-black/70 backdrop-blur-md text-white text-sm font-bold px-4 py-2 rounded-full">
              {currentGalleryImage + 1} / {imagenesProcesadas.length}
            </div>
          )}
        </div>

        {/* Miniaturas Inferiores */}
        {imagenesProcesadas.length > 1 && (
          <div className="h-[20vh] bg-black/80 backdrop-blur-md border-t border-white/10 p-4">
            <div className="flex gap-3 overflow-x-auto h-full items-center justify-center scrollbar-hide">
              {imagenesProcesadas.map((img, index) => (
                <button
                  key={index}
                  onClick={(e) => {
                    e.stopPropagation();
                    // Aquí necesitarías una función para cambiar la imagen actual
                  }}
                  className={`relative flex-shrink-0 w-24 h-16 rounded-lg overflow-hidden transition-all duration-300 ${
                    currentGalleryImage === index 
                      ? 'ring-2 ring-blue-500 ring-offset-2 scale-105' 
                      : 'opacity-60 hover:opacity-100'
                  }`}
                >
                  <img 
                    src={getSafeImageUrl(img)} 
                    className="w-full h-full object-cover" 
                    alt="" 
                    onError={(e) => {
                      e.target.src = 'https://via.placeholder.com/100x100?text=Error';
                    }}
                  />
                </button>
              ))}
            </div>
          </div>
        )}
      </div>
    </div>
  );
}   